// extracted by mini-css-extract-plugin
export default {"container":"TabsToggle_container__1kUca","tab":"TabsToggle_tab__ga5OU","active":"TabsToggle_active__PLgrj"};